<div class="skeleton-container">
  <div class="table-container">
    <div class="table-row table-header">
      <div class="header-cell"></div>
      <div class="header-cell">Interview section</div>
      <div class="header-cell"></div>
    </div>

    <div class="table-row">
      <div class="header-cell">Expert</div>
      <div class="header-cell">Question 1</div>
      <div class="skeleton-cell"></div>
    </div>

    @for (row of rows; track row) {
      <div class="table-row">
        @if (!segments[$index]) {
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
        } @else {
          <div class="respondent-cell flex flex-col">
            <span class="name">Jane Doe</span>
            <span>{{ segments[$index].segmentName }}</span>
          </div>
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
        }
      </div>
    }
  </div>

  <div class="footer-list">
    <div class="footer-sheet">
      <span>{{ sheetName }}</span>
    </div>
    <div class="footer-sheet plus">
      <span>+</span>
    </div>
  </div>
</div>
